<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { ArrowPathIcon } from '@heroicons/vue/24/outline'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  label?: string
}>()
</script>

<template>
  <div
    role="status"
    aria-live="polite"
    :class="cn('flex items-center justify-center gap-2 py-6 text-sm text-muted-fg', props.class)"
  >
    <ArrowPathIcon class="size-4 shrink-0 animate-spin" />
    <span>{{ label ?? 'Loading…' }}</span>
  </div>
</template>
